import { __assign } from "tslib";
export var textsApiRelativePath = "/helpcenter/texts";
export var textDefaultsApiRelativePath = "/apps/helpcenter/translations";
export var hcTextsApiRelativePath = '/helpcenter';
export var createTextsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + textsApiRelativePath;
    var hcApiUrl = "" + baseUrl + hcTextsApiRelativePath;
    return {
        getTextOverrides: function (dto) {
            return http.get(apiUrl + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updateTextOverrides: function (dto) {
            return http.post(apiUrl + "/" + dto.locale, dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        getHCTextDefaults: function (dto) {
            return http.get("" + dto.tenantDefaultHost + textDefaultsApiRelativePath + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        getCustomTexts: function (dto) {
            return http.get(hcApiUrl + "/" + dto.locale + "/contentAndStructure/customKeys" + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updateCustomTexts: function (dto) { return http.post(hcApiUrl + "/" + dto.locale + "/contentAndStructure/customKeys", dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data); },
    };
};
//# sourceMappingURL=index.js.map